/**
 * Pure helper for classifying what happened during Auth0 initialization: whether the
 * URL carries an error from Auth0. No window/history mutation, no SDK calls — see
 * src/auth/index.js for what the app actually does with the value derived here.
 *
 * Whether the current URL is an OAuth redirect callback (and for which provider) is
 * src/auth/provider.js's detectCallbackProvider()'s job - not duplicated here.
 */

export function parseAuthUrlError(search) {
    if (!search.includes('error=')) return null;

    const urlParams = new URLSearchParams(search);
    const error = urlParams.get('error');
    const errorDescription = urlParams.get('error_description');

    return {
        error,
        errorDescription,
        isPasswordExpired: error === 'access_denied' && !!errorDescription?.includes('PW_EXPIRED'),
    };
}

export function isSuccessfulAuth0Callback(callbackURL) {
    return callbackURL.includes('code=') && callbackURL.includes('state=') && !window.location.pathname.includes('/oauth2/authorized');
}
